import styled from 'styled-components';

export const Container = styled.div`
  padding: 1.5rem;
  float: left;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 50rem;

  @media (max-width: 1024px) {
    padding: 2rem 1rem;
  }
`;
